var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 321,
    viewBox: "0 0 320 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.6 266.4C323.1 278.9 323.1 299.15 310.6 311.65C304.4 317.9 296.2 321 288 321C279.8 321 271.62 317.875 265.38 311.625L160 206.3L54.63 311.6C48.38 317.9 40.19 321 32 321C23.81 321 15.63 317.9 9.375 311.6C-3.125 299.1 -3.125 278.85 9.375 266.35L114.775 160.95L9.375 55.6001C-3.125 43.1001 -3.125 22.8501 9.375 10.3501C21.875 -2.1499 42.125 -2.1499 54.625 10.3501L160 115.8L265.4 10.4001C277.9 -2.0999 298.15 -2.0999 310.65 10.4001C323.15 22.9001 323.15 43.1501 310.65 55.6501L205.25 161.05L310.6 266.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.50c3bd3e7b3ab712788d82366939d5de.svg";
export { ForwardRef as ReactComponent };